import { ActionsType } from "./actions";
import { StateType } from "./state";
export const appReducer = (state: StateType, action: ActionsType) => {
  return { ...state };
};
